import './ui/style.css';
import './ui/app/app.css';
import { Game } from './game/Game';
import { installFeatures } from './features';
import { playEmote } from './features/bonds';
import { install as installNet } from './net';

function unsupported(): boolean {
  if (document.createElement('canvas').getContext('webgl2')) return false;
  const el = document.createElement('div');
  el.style.cssText = 'position:fixed;inset:0;display:grid;place-items:center;color:#e9e4d6;font:16px/1.5 system-ui;text-align:center;padding:24px;background:#07080a';
  el.textContent = 'Aetherfall needs WebGL 2. Please use a recent version of Chrome, Edge, Firefox or Safari with hardware acceleration enabled.';
  document.body.appendChild(el);
  return true;
}

async function boot(): Promise<void> {
  if (unsupported()) return;
  const root = document.getElementById('app');
  if (!root) throw new Error('#app missing');
  const game = new Game(root);
  installFeatures(game);
  const net = installNet(game);
  // Other players' emotes play on their replicas.
  net.emoteHandler = (zone, actorId, emote) => void playEmote(zone, actorId, emote);
  (window as unknown as { __AF__: Game }).__AF__ = game;
  if (new URLSearchParams(location.search).has('e2e')) (await import('./testing/hooks')).installTestHooks(game);
  await game.init();
}

boot().catch((e: unknown) => {
  console.error(e);
  const el = document.createElement('pre');
  el.style.cssText = 'color:#f88;padding:20px;font:14px monospace;position:fixed;inset:0;z-index:99;background:#000c';
  el.textContent = String(e instanceof Error ? e.stack : e);
  document.body.appendChild(el);
});
